<template>
  <div>
    <div class="header-wrapper-exception redarc-banner">
      <h2>Black Diamond</h2>
      <hr class="line" />
    </div>
    <b-container>
      <div class="grid">
        <div class="text">
          <p>
            Marka Black Diamond została stworzona w 1993 roku w Wielkiej
            Brytanii. Głównym celem jaki przyświeca jej założycielom jest
            poprawa w jakości produkcji i dostępności niezawodnych części
            hamulcowych do aut sportowych. Dowodem na prawdziwość tego motta
            jest fakt, że gdy Black Diamond został zaproszony w 1996 roku do
            udziału w pierwszym teście prestiżowego brytyjskiego magazynu Max
            Power z miejsca został okrzyknięty jego zwycięzcą.
          </p>
          <p>
            Produkt Black Diamond osiągnął tak dużą przewagę nad innymi
            wiodącymi na rynku markami, że redaktorzy Max Power postanowili w
            ogóle nie przyznawać drugiego miejsca! A to nie koniec, w kolejnych
            latach przychodziły kolejne nagrody, zarówno dla tarcz, klocków
            hamulcowych jak i całych zestawów. Black Diamond słynie główne ze
            swoich nacinanych i wierconych tarcz hamulcowych oraz sportowych
            klocków Predator, ale w ofercie są w sumie cztery rodzaje tarcz, dwa
            typy klocków, stalowe przewody, płyny hamulcowe oraz sprzęgła.
          </p>
        </div>
        <div class="image">
          <picture>
            <source
              type="image/webp"
              srcset="./../../assets/brands-logos/bd.webp"
            />
            <img src="./../../assets/brands-logos/bd.png" alt="Black Diamond" />
          </picture>
        </div>
      </div>
    </b-container>
    <page-header
      :text="$t('importantLinks')"
      font="black"
      back="white"
    ></page-header>
    <b-container>
      <div class="link-items">
        <router-link to="/catalogue/black-diamond">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon
            >{{ $t("catalogue") }} ON-LINE
          </div>
        </router-link>
        <router-link to="/pricelist">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("pricelist") }}
          </div>
        </router-link>
        <a href="http://www.blackdiamondperformance.com/" target="_blank">
          <div class="link-item">
            <v-icon left class="icon">mdi-play</v-icon>{{ $t("website") }}
          </div>
        </a>
      </div>
      <brands class="brands" />
    </b-container>
  </div>
</template>

<script>
import Brands from "@/components/brands/Brands.vue";
import PageHeader from "@/components/common/PageHeader.vue";
import { mapGetters } from "vuex";

export default {
  name: "RedarcEn",
  components: { Brands, PageHeader },
  computed: {
    ...mapGetters(["isUserLogged"]),
  },
};
</script>
